import firebase from '@/plugins/firebase'
import http from './httpService'

export function authenticate(email, password) {
  if (!email) return console.log('email is undefined')
  return http.post(`/auth/login`, { email: email, password: password })
}
export function initializeAuthListener(callback) {
  return firebase.auth().onAuthStateChanged(callback)
}

export function getCurrentUser() {
  return firebase.auth().currentUser
}

export async function isUserAdmin() {
  return (await getClaims()).role === 'admin'
}

export async function getUserRole() {
  return (await getClaims())?.role || ''
}

export async function getUserLocale() {
  const localeMap = {
    'zh-hans': 'zh-hans',
    en: 'en',
  }
  const claims = await getClaims()
  return localeMap[claims.locale || 'en']
}

export function getUserToken(forceRefresh = false) {
  return getCurrentUser()?.getIdToken(forceRefresh)
}

export async function getClaims() {
  return (await getCurrentUser()?.getIdTokenResult())?.claims || {}
}
